import Skeleton from "@/common/components/Skeleton";
import { cn } from "@/common/utils/cn";
import { bankingDepositStatusComponent } from "@/features/bankingDeposits/constants/bankingDepositStatus.constant";
import { BankingDepositsData } from "@/features/bankingDeposits/types/bankingDeposits.type";

interface BankingDepositStatusProps {
  status?: BankingDepositsData['status'];
  isLoading?: boolean;
}

const BankingDepositStatus = ({ status, isLoading }: BankingDepositStatusProps) => {
  const Icon = status && bankingDepositStatusComponent[status].icon;

  if (isLoading) {
    return (
      <div className="flex items-center gap-4">
        <Skeleton circle height={70} />

        <div>
          <div className="h-8">
            <Skeleton height={28} width={250} />
          </div>

          <div className="h-6">
            <Skeleton height={20} width={250} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4">
      <div className={cn(
        'size-[70px] rounded-full flex items-center justify-center',
        status && bankingDepositStatusComponent[status].iconBackgroundClassName)}
      >
        {Icon && (
          <Icon
            strokeWidth={1.5}
            size={40}
            className={status && bankingDepositStatusComponent[status].iconClassName}
          />
        )}
      </div>

      <div>
        <p
          className={cn('text-2xl font-bold', status && bankingDepositStatusComponent[status].titleClassName)}
          data-testid="banking_deposit_status_component_title"
        >
          {status && bankingDepositStatusComponent[status].title || '--'}
        </p>

        <p data-testid="banking_deposit_status_component_subtitle">
          {status && bankingDepositStatusComponent[status].subtitle || '--'}
        </p>
      </div>
    </div>
  );
}

export default BankingDepositStatus;
